import { WishlistState } from '../types/WishlistState'

export const state: WishlistState = {
  products: []
}
